<ng-container *ngIf="item.attributes.used_data_sources?.length">
  <app-source class="display-inline"
              [enableTooltip]="false"
              [enableCategory]="true"
              [enableName]="false"
              [item]="item.attributes.used_data_sources[0]">
    <div class="display-flex flex-align-center gap-0-5em">
      <span>{{ item.attributes.used_data_sources[0].name }}</span>
      <ng-container *ngIf="item.attributes.used_data_sources.length > 1">
        <span> {{ 'reports.and' | translate }} {{ item.attributes.used_data_sources.length - 1 }} {{ 'reports.more' | translate }}</span>
        <mat-icon class="cursor mat-icon material-icons-outlined color-grey-light color-black-hover icon-info" customToolTip [contentTemplate]="tooltip">info</mat-icon>
      </ng-container>
    </div>
  </app-source>
</ng-container>
<ng-template #tooltip>
  <div *ngFor="let data_source of item.attributes.used_data_sources">
    <app-source [item]="data_source"
                [enableCategory]="true"></app-source>
  </div>
</ng-template>
